import { c as _c } from "react/compiler-runtime";
import { IcoCamera40, IcoClose24 } from '@onefootprint/icons';
import { IconButton } from '@onefootprint/ui';
import { Trans, useTranslation } from 'react-i18next';
import { TOUCH_TARGET_CLASS } from '@/idv2/components/constants';
import type { DeviceInfo } from '@/idv2/hooks';
import { isAndroid, isChrome, isIOS, isMobileKind, isSafari } from '../../utils/capture';
import IcoArrowCustom from './ico-arrow-custom';
type CameraAccessDeniedProps = {
  device: DeviceInfo;
  onClose: () => void;
};
const gifBaseUrl = 'https://i.onefp.net/i';
const CameraAccessDenied = t0 => {
  const $ = _c(36);
  const {
    onClose,
    device
  } = t0;
  let t1;
  if ($[0] !== device) {
    t1 = device || {};
    $[0] = device;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    browser,
    osName,
    type
  } = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "document-flow"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    t
  } = useTranslation("idv2", t2);
  let t3;
  if ($[3] !== osName || $[4] !== type) {
    t3 = isMobileKind(type) && isAndroid(osName);
    $[3] = osName;
    $[4] = type;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const isMobileOrTabletAndroid = t3;
  let t4;
  if ($[6] !== osName || $[7] !== type) {
    t4 = isMobileKind(type) && isIOS(osName);
    $[6] = osName;
    $[7] = type;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const isMobileOrTabletIOS = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <style>{"\n          @media (max-width: 899px) {\n            #footprint-footer { display: none; }\n            #idv-body-content-container > div { padding-bottom: 0; }\n          }\n        "}</style>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onClose) {
    t6 = <IconButton className={TOUCH_TARGET_CLASS} aria-label="Close camera access request" onClick={onClose} icon={IcoClose24} color="primary" />;
    $[10] = onClose;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== browser || $[13] !== isMobileOrTabletAndroid || $[14] !== isMobileOrTabletIOS) {
    t7 = isMobileOrTabletIOS && isSafari(browser) ? <div className="flex justify-center mb-10"><img src={`${gifBaseUrl}/settings-cam-ios-safari.gif`} alt="Settings camera for Safari on iOS" width="210" height="269" className="rounded-lg" /></div> : isMobileOrTabletIOS && isChrome(browser) ? <div className="flex justify-center mb-10"><img src={`${gifBaseUrl}/settings-cam-ios-chrome.gif`} alt="Settings camera for Chrome on iOS" width="210" height="269" className="rounded-lg" /></div> : isMobileOrTabletAndroid && isChrome(browser) ? <div className="flex justify-center mb-10"><img src={`${gifBaseUrl}/settings-cam-android-chrome.gif`} alt="Settings camera for Chrome on Android" width="210" height="233" className="rounded-lg" /></div> : <div className="flex justify-center mb-6"><IcoCamera40 color="primary" /></div>;
    $[12] = browser;
    $[13] = isMobileOrTabletAndroid;
    $[14] = isMobileOrTabletIOS;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t(_temp);
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <div className="text-heading-3 text-center mb-3 text-primary">{t8}</div>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== browser || $[21] !== isMobileOrTabletAndroid || $[22] !== isMobileOrTabletIOS || $[23] !== t) {
    t10 = isMobileOrTabletIOS && isSafari(browser) ? <><span className="text-body-1 text-center text-primary">{t(_temp2)}</span><span className="text-label-1 text-center text-primary">{t(_temp3)}</span></> : isMobileOrTabletIOS && isChrome(browser) ? <span className="text-body-1 text-center text-primary">{t(_temp4)}</span> : isMobileOrTabletAndroid && isChrome(browser) ? <span className="text-body-1 text-center text-primary"><Trans ns="idv2" i18nKey={_temp5} components={{
        bold: <strong />
      }} /></span> : <span className="text-body-1 text-center text-primary">{t(_temp6)}</span>;
    $[20] = browser;
    $[21] = isMobileOrTabletAndroid;
    $[22] = isMobileOrTabletIOS;
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t7 || $[27] !== t9) {
    t11 = <div className="flex flex-col justify-center h-full">{t7}{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t7;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== browser || $[30] !== isMobileOrTabletIOS) {
    t12 = isMobileOrTabletIOS && isSafari(browser) ? <div className="ml-6"><IcoArrowCustom /></div> : null;
    $[29] = browser;
    $[30] = isMobileOrTabletIOS;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t11 || $[33] !== t12 || $[34] !== t6) {
    t13 = <>{t5}{t6}{t11}{t12}</>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t6;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
};
export default CameraAccessDenied;
function _temp($) {
  return $["access-camera"];
}
function _temp2($_0) {
  return $_0["go-to-camera-settings"];
}
function _temp3($_1) {
  return $_1["then-refresh-page"];
}
function _temp4($_2) {
  return $_2["go-to-chrome-settings"];
}
function _temp5($_3) {
  return $_3["document-flow"]["go-to-chrome-url"];
}
function _temp6($_4) {
  return $_4["go-to-device-settings"];
}